/**
 * NjitProfileOverlay behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.NjitProfileOverlay.attach}}
   */
  Drupal.behaviors.NjitProfileOverlay = {
    attach: function (context, settings) {
      $(".colorbox-profile-overlay").colorbox({
        fixed: false,
        scrolling: true,
        overlayClose: true,
        escKey: true,
        inline: true,
        width: '1100px',
        height: '960px',
        top: '129px',
        className: 'colorbox-njit',
        onOpen: function() {
          $(window).on('update.tabs', function() {
            $.colorbox.resize();
          });
        },
        onComplete: function() {
          Drupal.attachBehaviors(Drupal.NjitTabbedContent);
        },
        onClosed: function() {

        }
      });
    }
  };
})(Drupal, jQuery);
